// removed by extract-text-webpack-plugin
module.exports = {"bgimage":"src-components-BackgroundImage----backgroundimage-module---bgimage---2RBQq","in":"src-components-BackgroundImage----backgroundimage-module---in---1XRDO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BackgroundImage/backgroundimage.module.scss
// module id = 299
// module chunks = 168707334958949